import { render } from "./ProgramBenefitsTwo.vue?vue&type=template&id=b854ce60&scoped=true"
import script from "./ProgramBenefitsTwo.vue?vue&type=script&lang=js"
export * from "./ProgramBenefitsTwo.vue?vue&type=script&lang=js"

import "./ProgramBenefitsTwo.vue?vue&type=style&index=0&id=b854ce60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b854ce60"]])

export default __exports__